import {BulkEditChangeTypeEnum} from './bulk-edit-change-type.enum';
import {BulkEditChangeRecord} from './bulk-edit-change-record';
import {AppUtils} from '../shared/app-utils';
import {Locale} from './locale';
import {Program} from './program';
import {RelevantBulkEditChangesFilterPipe} from '../pipes/bulk-edit/relevant-bulk-edit-changes-filter.pipe';
import {BulkEditChangeRecordResult} from './bulk-edit-change-record-result';
import {factory} from '../shared/app-logging';
import {Product} from './product';

const logger = factory.getLogger('BulkEditSession');



export class ExcelFileReadMessage {
  constructor(public title: string, public description: string) {
  }
}

export class ExcelFileReadEvent {
  constructor(public result: BulkEditSession,
              public warnings: Array<ExcelFileReadMessage>,
              public errors: Array<ExcelFileReadMessage>) {
  }
}

export class BulkEditSession {
  public result = new Array<BulkEditChangeRecordResult>();

  constructor(
    public file: File,
    public binStringFileContent: string,
    public generationDate: Date,
    public locale: Locale,
    public product: Product,
    public changes: Map<BulkEditChangeTypeEnum, Array<BulkEditChangeRecord>>,
    public parsingDate?: Date,
    public error?: ErrorEvent
  ) {
    this.parsingDate = parsingDate ? parsingDate : new Date();
    if (!changes) {
      this.changes = new Map<BulkEditChangeTypeEnum, Array<BulkEditChangeRecord>>();
      for (const changeType of AppUtils.getEnumIndexes(BulkEditChangeTypeEnum)) {
        this.changes.set(BulkEditChangeTypeEnum[changeType], []);
      }
    }
  }

  public getChangeTypes(): Array<BulkEditChangeTypeEnum> {
    const result = [];
    if (!this.changes) {
      return result;
    }
    const keyIterator = this.changes.keys();
    let key: IteratorResult<BulkEditChangeTypeEnum> = keyIterator.next();
    while (!key.done) {
      result.push(key.value);
      key = keyIterator.next();
    }
    return result;
  }

  public getChangesToPerform(): Array<BulkEditChangeRecord> {
    const changeTypesToPerform = RelevantBulkEditChangesFilterPipe.filter(this.getChangeTypes(), this, false);
    let changesToPerform: Array<BulkEditChangeRecord> = [];
    for (const type of changeTypesToPerform) {
      changesToPerform = changesToPerform.concat(this.changes.get(type));
    }
    return changesToPerform;
  }

  public getChangesPerformed(): Array<BulkEditChangeRecord> {
    const changesPerformed: Array<BulkEditChangeRecord> = [];
    for (const res of this.result) {
      changesPerformed.push(res.bulkEditRecord);
    }
    return changesPerformed;
  }

  public hasResultErrors(): boolean {
    return this.result.some(res => res.bulkEditRecord.error !== undefined);
  }

  public getResultErrors(): Array<BulkEditChangeRecordResult> {
    return this.result.filter(res => res.bulkEditRecord.error !== undefined);
  }

  public isDefaultCombination() {
    return this.locale.localeName === 'en_US' && (!this.product || !this.product.id || this.product.displayLabel === 'DEFAULT');
  }

}
